/* Tarjetas de catálogo · cambia sola la foto cada 10 s (home y colección) */
(function () {
  if (window.__mSwap) return; window.__mSwap = 1;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var EVERY = 10000, timer = null;
  function cards() {
    return Array.prototype.filter.call(document.querySelectorAll('.m-card'), function (c) {
      return c.querySelectorAll('.m-card__img img').length > 1;
    });
  }
  /* precarga la segunda foto para que el primer cambio no llegue vacío */
  function preload() {
    cards().forEach(function (c) {
      var im = c.querySelectorAll('.m-card__img img')[1];
      if (im && !im.complete) im.loading = 'eager';
    });
  }
  function tick() {
    if (document.hidden) return;
    cards().forEach(function (c) { c.classList.toggle('is-alt'); });
  }
  function start() { if (!timer) timer = setInterval(tick, EVERY); }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
  setTimeout(preload, 1500);
  start();
})();
